
































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { TokenData } from '@/types/customerInfo';
@Component
export default class Landing extends Vue {
  @Action getFiConfig!: (fiId: string) => void;
  @Getter('tokenData') tokenData!: TokenData;
  @Mutation('SET_TOKEN_DATA') setTokenData!: (tokenData: TokenData) => void;

  async failureEndpoint() {
    if (this.loading) {
      return;
    }
    this.$router.push('/pin-set/failure');
  }

  async successEndpoint() {
    if (this.loading) {
      return;
    }
    this.$router.push('/pin-set/success');
  }

  loading = false;
}
